import React, { useState } from 'react';

const DAYS = [[1, 'Mo'], [2, 'Di'], [3, 'Mi'], [4, 'Do'], [5, 'Fr'], [6, 'Sa'], [7, 'So']];

export default function RetouchCalendarOptions({ clientName, weekdays, onWeekdaysChange, onCancel }) {
  const [expanded, setExpanded] = useState(false);
  const summary = weekdays.length ? DAYS.filter(([id]) => weekdays.includes(id)).map(([, name]) => name).join(', ') : 'Alle Tage';
  const toggle = id => onWeekdaysChange(weekdays.includes(id) ? weekdays.filter(day => day !== id) : [...weekdays, id]);
  return <div className={`retouch-calendar-command retouch-calendar-options ${expanded ? 'is-expanded' : ''}`}>
    <div className="retouch-command-heading">
      <span className="retouch-calendar-label">NACHSTECHEN</span>
      <strong>{clientName}</strong>
      <button type="button" className="retouch-command-cancel" onClick={onCancel} aria-label="Nachstech-Modus beenden">✕</button>
    </div>
    <div className="retouch-command-tools">
      <span>Gestrichelten Tag antippen</span>
      <button type="button" aria-expanded={expanded} aria-controls="retouch-weekday-options" onClick={() => setExpanded(!expanded)}>
        Tage: {summary} <span aria-hidden="true">{expanded ? '⌃' : '⌄'}</span>
      </button>
    </div>
    {expanded && <div className="retouch-weekday-options" id="retouch-weekday-options">
      <div className="retouch-weekday-shortcuts" role="group" aria-label="Schnellauswahl">
        <button type="button" aria-pressed={weekdays.length === 0} onClick={() => onWeekdaysChange([])}>Alle Tage</button>
        <button type="button" aria-pressed={weekdays.length === 2 && weekdays.includes(6) && weekdays.includes(7)} onClick={() => onWeekdaysChange([6, 7])}>Wochenende</button>
      </div>
      <div className="retouch-weekday-chips" role="group" aria-label="Wochentage auswählen">
        {DAYS.map(([id, name]) => <button key={id} type="button" aria-pressed={weekdays.includes(id)} onClick={() => toggle(id)}>{name}</button>)}
      </div>
    </div>}
  </div>;
}
